// export const BaseUrl = "https://atlo-client-backend.vercel.app/";
export const BaseUrl = "https://at-lo.in/api/";

const syncAuthToken = () => {
  const sessionToken = sessionStorage.getItem('token');
  const localToken = localStorage.getItem('token');
  const token = sessionToken || localToken;

  if (token) {
    if (token !== sessionToken) sessionStorage.setItem('token', token);
    if (token !== localToken) localStorage.setItem('token', token);
  }

  return token;
};

export const getAuthHeaders = () => {
  const token = syncAuthToken();
  return {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
};